import React from "react";
import { Card, Table } from "react-bootstrap";
import UltimatePagination from "../../../partials/layout/PaginationComponent";

const PsSummary = ({
    psSummary,
    totalRecords,
    currentPage,
    limit,
    onPageChange
}) => {
    return (
        <Card className="dashboard-card">
            <Card.Header className="dashboard-card-header">
                PS Wise Activity Summary
            </Card.Header>

            <Card.Body className="p-0">
                <div className="summary-scroll">
                    <Table
                        responsive
                        hover
                        className="mb-0"
                    >
                        <thead>
                            <tr>
                                <th>PS Name</th>
                                <th>Total</th>
                                <th>SR</th>
                                <th>Reports</th>
                                <th>Distance</th>
                            </tr>
                        </thead>

                        <tbody>
                            {psSummary.map((item) => (
                                <tr key={item.psId}>
                                    <td>
                                        <div className="ps-name">
                                            {item.psName}
                                        </div>
                                    </td>

                                    <td>
                                        <strong>
                                            {
                                                item.totalJobsDone
                                            }
                                        </strong>
                                    </td>

                                    <td>
                                        {
                                            item.serviceRequestJobsDone
                                        }
                                    </td>

                                    <td>
                                        {
                                            item.reportJobsDone
                                        }
                                    </td>

                                    <td>
                                        {Number(
                                            item.totalDistanceTravelled || 0
                                        ).toFixed(2)}{" "}
                                        km
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>

                {totalRecords > limit && (
                    <div className="p-2">
                        <UltimatePagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(
                                totalRecords / limit
                            )}
                            onChange={onPageChange}
                        />
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default PsSummary;